<div class="match-parent">
    <div class="map" [id]="mapId"></div>
</div>
